export default __webpack_public_path__ + "static/media/app-twitter.e7c878c3.jpg";